import { createFileRoute, Link } from '@tanstack/react-router'
import { useAuthStore } from '@zendia/frontend-shared'

export const Route = createFileRoute('/_unauthenticated/')({
  component: HomeComponent,
})

function HomeComponent() {
  const { authToken } = useAuthStore()

  return (
    <div>
      <div className="text-2xl font-bold mb-4">Welcome to Zendia Koi!</div>
      {/* <div className="text-lg font-thin">{response?.data?.message}</div> */}
      <div className="mt-4 space-x-2">
        <Link
          to="/onboarding"
          className="nav-link inline-block px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors duration-200 font-semibold"
        >
          Sign Up
        </Link>
        {authToken ? (
          <Link
            to="/dashboard"
            className="nav-link inline-block px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors duration-200 font-semibold"
          >
            Dashboard
          </Link>
        ) : (
          <Link
            to="/login"
            className="nav-link inline-block px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors duration-200 font-semibold"
          >
            Sign in
          </Link>
        )}
      </div>
    </div>
  )
}
